import { useGLTF } from '@react-three/drei'
import { useFrame } from '@react-three/fiber'
import { useEffect, useRef, useState } from 'react'

export const Model = ({
  url,
  onClick,
  spin,
}: {
  url: string
  onClick?: () => void
  spin?: boolean
}) => {
  const { scene } = useGLTF(url)

  const [initialRotation, setInitialRotation] = useState(0)
  const wasSpinning = useRef<boolean>(false)

  useEffect(() => {
    if (scene) {
      setInitialRotation(scene.rotation.y)
    }
  }, [scene])

  useFrame(() => {
    if (spin) {
      scene.rotation.y -= 0.001
      wasSpinning.current = true
    } else {
      if (wasSpinning.current) {
        scene.rotation.y = initialRotation
        wasSpinning.current = false
      }
    }
  })

  return <primitive object={scene} onClick={onClick} />
}

export default Model
